export default __webpack_public_path__ + "asset/img/no-data-v3~095f0964.png";